import { Info } from '@mui/icons-material';
import { Chip, ChipProps } from '@mui/material';
import { ReactNode, useState } from 'react';
import { Union } from 'ts-toolbelt';

import { InfoDrawer } from '~/components/InfoDrawer/InfoDrawer';

interface InfoChipInfo {
  headline: ReactNode;
  subHeadline: ReactNode;
  description: ReactNode;
}

interface InfoChipState {
  open: boolean;
  info?: Union.Nullable<InfoChipInfo>;
}

export type InfoChipInfoGetter = () => InfoChipInfo;

interface InfoChipProps extends Omit<ChipProps, 'deleteIcon' | 'onDelete'> {
  infoGetter: InfoChipInfoGetter;
}

export const InfoChip = ({ infoGetter, ...chipProps }: InfoChipProps) => {
  const [state, setState] = useState<InfoChipState>({ open: false });
  if (chipProps.label) {
    return (
      <>
        <Chip
          {...chipProps}
          deleteIcon={<Info />}
          onDelete={() => {
            setState({ open: true, info: infoGetter() });
          }}
        />
        <InfoDrawer
          {...state.info}
          open={state.open}
          onClose={() => {
            setState((prev) => ({ ...prev, open: false }));
          }}
        />
      </>
    );
  }
  return null;
};
